import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISetNameParams } from '../../../spacesPlatform/utils/actionParams';

export class RenameMetricRequest extends Request<ISetNameParams, IEmptyResult> {
  constructor(id: string, name: string) {
    super('renameMetric', {
      id: id,
      name: name
    });
  }
}
